export default "__VITE_ASSET__CsI7YPwX__";